exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".KSaKz{position:fixed;top:0;left:0;width:100%;background:rgba(0,0,0,.8);padding:13px 20px;-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:-webkit-transform .1s linear;transition:-webkit-transform .1s linear;-o-transition:transform .1s linear;transition:transform .1s linear;transition:transform .1s linear,-webkit-transform .1s linear;z-index:10000}._2sO61{background:#e73232;color:#fff}._2A3gx{background:#ffd906;color:#000}._1aLfe{background:#4caf10;color:#fff}._2pXnf{background:#2196f3;color:#fff}.bzlx8{-webkit-transform:translateY(0);transform:translateY(0)}._1WJlP{color:#fff;text-align:center;max-width:800px;margin:0 auto}@media print{.KSaKz{display:none}}", ""]);

// exports
exports.locals = {
	"root": "KSaKz",
	"error": "_2sO61",
	"warning": "_2A3gx",
	"success": "_1aLfe",
	"info": "_2pXnf",
	"active": "bzlx8",
	"label": "_1WJlP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Layout/NotificationBar/NotificationBar.css
// module id = 1385
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46